import { render, staticRenderFns } from "./SfAccordion.vue?vue&type=template&id=45b43e73&"
import script from "./SfAccordion.vue?vue&type=script&lang=js&"
export * from "./SfAccordion.vue?vue&type=script&lang=js&"
import style0 from "./SfAccordion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports